import React from 'react'
import {connect} from 'react-redux'
import {forbidClickSelector} from '../../modules/app'


let ForbidClickLayer = ({forbidClick}) => forbidClick && <div className="forbid-click"></div>

export default connect(
    state => ({
        forbidClick : forbidClickSelector(state)
    })
)(ForbidClickLayer)


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/common/ForbidClickLayer.js